<i18n src="@/i18n/components/AdvancedFilter.json"></i18n>
<template>
	<p type="button" class="drop relative rounded px-2.5 py-1.5 text-gray-600 bg-white/40 hover:bg-white hover:text-gray-800" :class="wrapperClass" @click="handleShowConfig">
		<button v-if="!filter.required" type="button" @click="handleRemove" class="mr-3 text-gray-400 hover:text-red-500">
			<i class="fa fa-times-circle"></i>
		</button>
		<template v-if="filter.field && filter.field.field === '$search'">
			<span class="inline-flex space-x-1 text-center">{{ $t('advanced_filter.labels.contains_text') }}</span>
			<span class="ml-2 font-semibold">{{ filter.value }}</span>
		</template>
		<template v-else>
			<button type="button" class="inline-flex space-x-1 text-center" :class="filter.inline && 'cursor-default'" @click="handleShowConfig">
				<template v-if="!filter.value && !filter.operator && !filter.field">
					<span>Filtro</span>
				</template>
				<template v-else>
					<!-- Field !-->
					<template v-if="filter.field">
						<span class="font-semibold">{{ filter.field.label }}</span>
					</template>
					<!-- / Field !-->
					<!-- operator !-->
					<template v-if="filter.operator">
						<span class="text-gray-700">{{ $t(`advanced_filter.filters.${filter.operator}`) }}</span>
					</template>
					<!-- / operator !-->
					<!-- operator !-->
					<span class="font-semibold max-w-[120px] truncate">{{ filterValue }}</span>
				</template>
				<!-- / operator !-->
			</button>
			<!-- Config !-->
			<AdvancedFilterOperation :show="showConfig" @update:show="handleShow" :fields="fields" :filter="filter" @update:filter="handleUpdateFilter" @apply="$emit('apply', $event)"/>
		</template>
	</p>
</template>

<script>
import AdvancedFilterOperation from "@/components/AdvancedFilter/AdvancedFilterOperation.vue"

export default {
	name: "AdvancedFilterItem",
	components: {AdvancedFilterOperation},
	model: {
		prop: "filter",
		event: "update:filter"
	},
	emits: ["update:filter", "remove"],
	props: {
		fields: {
			type: Array,
			required: true
		},
		filter: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			showConfig: false
		}
	},
	computed: {
		wrapperClass() {
			if (this.filter.field?.field !== '$search' && (!this.filter.field || !this.filter.operator || !this.filter.value)) {
				return 'border border-dashed border-gray-400'
			}
			return 'shadow border border-transparent'
		},
		filterValue(){

			const value = this.filter?.value

			if(!value) return '?'

			if(value instanceof Date){
				return this.$displayDate(value)
			}

			if(Array.isArray(value)){
				return value.map(item => this.optionLabel(item)).join(', ')
			}

			if(typeof value === 'object'){
				return this.optionLabel(value)
			}

			return value
		}
	},
	methods: {
		/**
		 * Text of the selected value: each select returns the label on a different key
		 * (sometimes localized per language) and the chip needs plain text
		 * @param option
		 * @returns {string}
		 */
		optionLabel(option){

			if(!option || typeof option !== 'object') return option ?? '?'

			const label = option.label ?? option.label_locale ?? option.title_locale ?? option.title ?? option.name

			if(!label) return '?'

			return typeof label === 'object' ? this.$localize(label) : label
		},
		/**
		 * Handle show
		 * @param evt
		 */
		handleShow(evt) {
			this.showConfig = evt
			if (!this.filter.field || !this.filter.operator || !this.filter.value) {
				this.$emit('remove', this.filter)
			}
		},
		/**
		 * Handle update filter
		 * @param filter
		 */
		handleUpdateFilter(filter) {
			this.$emit('update:filter', filter)
			// this.showConfig = false
		},
		/**
		 * Handle click
		 */
		handleShowConfig() {
			if(this.filter.inline) return;
			this.showConfig = true
		},
		handleCloseConfig() {
			this.showConfig = false
		},
		/**
		 * Handle remove
		 */
		handleRemove() {
			this.$emit('remove', this.filter)
		},
	},
	mounted() {
		if (!this.filter.value) {
			this.showConfig = true
		}
	}
}
</script>